import React from 'react'
import { Avatar, Col, Container, Link, Row } from '@paypalcorp/pp-react'
import { ActivityItemParam } from '../utils/activityItem'
import { getTransactionDetailURL } from '../../../utils/links/transactionLink'

interface ActivityItemTemplateProps {
  isAdmin: boolean
  item: ActivityItemParam
  contributorAmount: React.ReactNode
  renderActivityPerson: (data: any) => React.ReactNode
  renderActivityTime: (data: any) => React.ReactNode
  renderDescription: (data: any) => React.ReactNode
  onActivityLinkClick: () => void
  styles: any
}

const ActivityItemTemplate = ({
  isAdmin,
  item,
  contributorAmount,
  renderActivityPerson,
  renderActivityTime,
  renderDescription,
  onActivityLinkClick,
  styles,
}: ActivityItemTemplateProps) => {
  const renderAvatarImg = (link: string, initials: string) => {
    return (
      <Avatar
        alt=""
        src={link}
        generic={initials ? undefined : 'profile'}
        data-testid={initials ? 'activityAvatar' : 'anonymousAvatar'}
        initials={initials}
        size="sm"
        aria-hidden="true"
      />
    )
  }

  const activityItemContainer = (
    <Container form={true}>
      <Row>
        <Col xs={12}>
          <div className={styles.activityItemContainer}>
            <div>
              {renderAvatarImg(item.profilePhotoUrl, item.personInitials)}
            </div>
            <div className={styles.activityItemDetailsContainer}>
              <div className={styles.activityItemMainDetails}>
                <div
                  className={styles.activityItemTimeAndPerson}
                  data-testid="personActivity"
                >
                  {item.person && renderActivityPerson(item.person)}
                  {item.time && renderActivityTime(item.time)}
                </div>
                <div className={styles.activityItemAmount}>
                  {contributorAmount}
                </div>
              </div>
              {item.description && renderDescription(item.description)}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )

  const listItemStyle = isAdmin
    ? styles.activityDetailStylesCreator
    : styles.activityDetailStylesContributor

  return (
    <li className={listItemStyle} data-testid="cardActivity">
      {isAdmin ? (
        <Link
          href={getTransactionDetailURL(item.transactionId)}
          className={styles.activityDetailLink}
          data-testid="activity-link"
          onClick={onActivityLinkClick}
        >
          {activityItemContainer}
        </Link>
      ) : (
        activityItemContainer
      )}
    </li>
  )
}

export default ActivityItemTemplate
